import { NavItemId } from './nav-item-id.model';
import { PrefixedId } from './prefixed-id';
export const NavStructureId = PrefixedId('sid::');
export const sid = NavStructureId.create;

/**
 * Build a stable {@link NavStructureId} for a node from its ancestors. The
 * result is an opaque handle — compare it, never parse it.
 *
 * @param own the node's own id; a {@link NavItemId} has its `nid::` prefix stripped.
 * @param ancestors the node's ancestor structure ids, outermost first.
 */
export const createStructureId = (own, ancestors = []) => {
  const ownSegment = NavItemId.strip(own);
  if (ancestors.length === 0) {
    return NavStructureId.create(ownSegment);
  }
  const path = ancestors.map(ancestor => {
    const segments = NavStructureId.strip(ancestor).split('/');
    return segments[segments.length - 1];
  });
  return NavStructureId.create(`${path.join('/')}/${ownSegment}`);
};